/* feedback-modal.tsx generated by @compiled/babel-plugin v0.38.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./feedback-modal.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Fragment, lazy, Suspense, useCallback, useState } from 'react';
import { useIntl } from 'react-intl-next';
import Checkbox from '@atlaskit/checkbox';
import { Box } from '@atlaskit/primitives/compiled';
import { useAIAnswerContext } from '../../../ai-answer-dialog/ai-answer-context';
import { FEEDBACK_CONTEXT_CF, FEEDBACK_ENTRYPOINT_ID_DEFINITIONS } from '../common/constants';
import { messages } from './messages';
var styles = {
  root: "_n3tdpxbi"
};
var AkFeedbackCollector = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/product-search-dialog/feedback-collector" */'@atlaskit/feedback-collector').then(function (module) {
    return {
      default: module.default
    };
  });
});
export var FeedbackModal = function FeedbackModal(_ref) {
  var setFeedbackModal = _ref.setFeedbackModal,
    isCuratedDefinition = _ref.isCuratedDefinition,
    setDisplayFlag = _ref.setDisplayFlag;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage,
    locale = _useIntl.locale;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    readingAidsOptions = _useAIAnswerContext.readingAidsOptions,
    _useAIAnswerContext$u = _useAIAnswerContext.userDetails,
    name = _useAIAnswerContext$u.name,
    id = _useAIAnswerContext$u.id;
  var errorState = commonAttributes.errorState;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasConsent = _useState2[0],
    setConsent = _useState2[1];
  var feedbackContextObject = {
    source: commonAttributes.source,
    queryHash: commonAttributes.queryHash,
    cloudId: commonAttributes.cloudId,
    prompt: hasConsent ? commonAttributes.query : undefined,
    answer: hasConsent ? commonAttributes.answerString : undefined,
    documentId: readingAidsOptions === null || readingAidsOptions === void 0 ? void 0 : readingAidsOptions.contentARI,
    errorState: errorState,
    isCuratedDefinition: isCuratedDefinition
  };
  var feedbackContext = Object.entries(feedbackContextObject).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return "".concat(key, ": ").concat(value);
  }).join(', ');
  var toggleConsentCheckbox = useCallback(function () {
    setConsent(!hasConsent);
  }, [hasConsent]);
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Fragment, null)
  }, /*#__PURE__*/React.createElement(AkFeedbackCollector, {
    locale: locale,
    onClose: function onClose() {
      return setFeedbackModal(false);
    },
    onSubmit: function onSubmit() {
      setDisplayFlag(true);
    },
    customContent: isCuratedDefinition ? undefined : /*#__PURE__*/React.createElement(Checkbox, {
      label: formatMessage(messages.definition_footer_feedback_consent_checkbox_label),
      onChange: toggleConsentCheckbox,
      isChecked: hasConsent
    }),
    atlassianAccountId: id,
    name: name,
    entrypointId: FEEDBACK_ENTRYPOINT_ID_DEFINITIONS,
    additionalFields: [{
      id: FEEDBACK_CONTEXT_CF,
      value: feedbackContext
    }],
    feedbackTitle: formatMessage(messages.definition_footer_feedback_modal_header),
    feedbackTitleDetails: /*#__PURE__*/React.createElement(Box, {
      xcss: styles.root
    }, formatMessage(messages.definition_footer_feedback_report_label)),
    feedbackGroupLabels: {
      empty: {
        fieldLabel: formatMessage(messages.definition_footer_feedback_report_details_label),
        selectOptionLabel: formatMessage(messages.definition_footer_feedback_report_empty_option_share_label)
      },
      question: {
        fieldLabel: formatMessage(messages.definition_footer_feedback_report_details_label),
        selectOptionLabel: formatMessage(messages.definition_footer_feedback_report_relevance_option_label)
      },
      comment: {
        fieldLabel: formatMessage(messages.definition_footer_feedback_report_details_label),
        selectOptionLabel: formatMessage(messages.definition_footer_feedback_report_inaccurate_option_label)
      },
      bug: {
        fieldLabel: formatMessage(messages.definition_footer_feedback_report_details_label),
        selectOptionLabel: formatMessage(messages.definition_footer_feedback_report_offensive_option_label)
      },
      suggestion: {
        fieldLabel: formatMessage(messages.definition_footer_feedback_report_details_label),
        selectOptionLabel: formatMessage(messages.definition_footer_feedback_report_other_option_label)
      }
    },
    summaryPlaceholder: formatMessage(messages.definition_footer_feedback_summary_placeholder_label)
  })));
};